/**
 * @fileoverview Company attribution.
 *
 * The product is "Hans"; the company behind it is "Kalver". These are the
 * single flip point for that attribution — nothing else should hardcode the
 * company name, site label or a contact address, because these strings land
 * in the Terms and Privacy pages and in generated lesson PDFs.
 *
 * They read as functions rather than constants because they used to be
 * hostname-conditional (Lab_401 on the retired lab401.ai domain, Kalver
 * everywhere else). Keeping the call shape means the ~30 call sites did not
 * have to change when that domain went away, and it leaves one obvious place
 * to reintroduce a condition if attribution ever varies again.
 */

/** Short brand name for footers/attribution lines ("by Kalver"). */
export function companyName() {
  return "Kalver";
}

/** Legal entity name for Terms/Privacy ("Kalver, Inc."). */
export function companyLegalName() {
  return "Kalver, Inc.";
}

/** Site shown in generated-document footers (lesson PDFs). */
export function companySiteLabel() {
  return "hans.kalver.ai";
}

/** Support contact shown across the guide, footer, settings and legal pages. */
export function supportEmail() {
  return "support@kalver.ai";
}

/** Privacy contact — the address named in the consent text and Privacy page. */
export function privacyEmail() {
  return "privacy@kalver.ai";
}
